
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WIPTransactionSelectGrid extends _Ext.GridBase<WIPTransactionRow, any> {
        protected getColumnsKey() { return 'Production.DismantlingSelect'; }
        protected getDialogType() { return <any>WIPTransactionDialog; }
        protected getIdProperty() { return WIPTransactionRow.idProperty; }
        protected getLocalTextPrefix() { return WIPTransactionRow.localTextPrefix; }
        protected getService() { return DismantlingReturnWIPService.baseUrl; }
        //protected getInsertPermission() { return WIPTransactionRow.insertPermission; }
        //protected getUpdatePermission() { return WIPTransactionRow.updatePermission; }
        //protected getDeletePermission() { return WIPTransactionRow.deletePermission; }
        //protected useViewMode() { return true; }  
   
        constructor(container: JQuery) {
            super(container); 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            return grid;
        }

        private autoSize;


        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): WIPTransactionRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            return true;

        }

    } 
}